import React from 'react';
import './App.css';
import SlideContainer from './components/SlideContainer';

function App() {
  return (
    <div className="App">
      <SlideContainer />
    </div>
  );
}

export default App;
